export class ClaraStreamInterruptedError extends Error {
  constructor(public readonly reason: string = "") {
    super("Clara stream ended before the answer was complete");
    this.name = "ClaraStreamInterruptedError";
  }
}
